module.exports = __webpack_public_path__ + "static/img/excel-01.fe540e3c.png";